import { connect } from 'react-redux';

import { IState } from '../../store/index';
import { IKpInfoProps, KpInfo } from './KpInfo';

export function mapStateToProps(state: IState): IKpInfoProps {
  return {
    kp: state.offerData.kp,
    offer: state.offerData.offer,
    agent: state.offerData.agent,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const KpInfoContainer = connect<IKpInfoProps, any, any>(mapStateToProps)(KpInfo);
